/*
 * PRD-037 — Auth context PROPIO del portal del partner (app separada).
 * Token de partner en memoria (efímero). NO usa el AuthContext del panel.
 */
import { createContext, useContext, useState, type ReactNode } from 'react';
import type { PartnerInfo } from '@services/partnerService';

interface PartnerAuthState {
  token: string | null;
  partner: PartnerInfo | null;
  login: (token: string, partner: PartnerInfo) => void;
  logout: () => void;
}

const PartnerAuthCtx = createContext<PartnerAuthState>({
  token: null,
  partner: null,
  login: () => undefined,
  logout: () => undefined,
});

export const usePartnerAuth = () => useContext(PartnerAuthCtx);

export const PartnerAuthProvider = ({ children }: { children: ReactNode }) => {
  const [token, setToken] = useState<string | null>(null);
  const [partner, setPartner] = useState<PartnerInfo | null>(null);
  const login = (t: string, p: PartnerInfo) => {
    setToken(t);
    setPartner(p);
  };
  const logout = () => {
    setToken(null);
    setPartner(null);
  };
  return <PartnerAuthCtx.Provider value={{ token, partner, login, logout }}>{children}</PartnerAuthCtx.Provider>;
};
